import axios from 'axios';
import config from '../config';
import store from 'store';

const instance = axios.create ({
  baseURL: config.API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  },
});

instance.interceptors.request.use (
  function (config) {
    const token = store.get('token');

    if (token) {
      config.headers.token = token;
    }

    return config;
  },
  function (error) {
    return Promise.reject (error);
  }
);

export default instance;
